import { css, styled } from 'styled-components';

import { textColors } from '../../theme/palette';

import type { TextProps, TextVariant } from './types';

const stylesByVariant: Record<TextVariant, ReturnType<typeof css>> = {
  body: css`
    font-weight: ${({ theme }) => theme.designTokens.textBodyFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textBodyFontSize};
    line-height: ${({ theme }) => theme.designTokens.textBodyLineHeight};
  `,
  'body-light': css`
    font-weight: ${({ theme }) => theme.designTokens.textBodyLightFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textBodyLightFontSize};
    line-height: ${({ theme }) => theme.designTokens.textBodyLightLineHeight};
  `,
  'body-lighter': css`
    font-weight: ${({ theme }) => theme.designTokens.textBodyLighterFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textBodyLighterFontSize};
    line-height: ${({ theme }) => theme.designTokens.textBodyLighterLineHeight};
  `,
  caption: css`
    display: inline-block;
    font-weight: ${({ theme }) => theme.designTokens.textCaptionFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textCaptionFontSize};
    line-height: ${({ theme }) => theme.designTokens.textCaptionLineHeight};
    & > & {
      font-size: 0.8125em;
      line-height: 1em;
      vertical-align: baseline;
    }
  `,
};

const propsToOmitInDOM: Set<keyof TextProps> = new Set([
  'variant',
  'textAlign',
  'textDecoration',
  'textOverflow',
  'textTransform',
]);

const Span = styled.span.withConfig({
  shouldForwardProp: prop => !propsToOmitInDOM.has(prop as keyof TextProps),
})<TextProps>`
  margin: 0;
  font: inherit;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.designTokens.textFontFamily};
  color: ${({ theme, color }) => (color ? textColors[color] : theme.designTokens.textTextColor)};
  letter-spacing: ${({ theme }) => theme.designTokens.textLetterSpacing};
  vertical-align: middle;
  text-align: ${({ textAlign: align }) => align};
  text-decoration: ${({ textDecoration: decoration }) => decoration};
  text-overflow: ${({ textOverflow }) => textOverflow};
  ${({ textOverflow }) =>
    (textOverflow === 'clip' || textOverflow === 'ellipsis') &&
    css`
      white-space: nowrap;
      overflow-x: hidden;
    `}
  text-rendering: optimizeLegibility;
  text-transform: ${({ textTransform }) => textTransform};
  ${({ variant }) => stylesByVariant[variant]}
`;

export const Styled = {
  Span,
};
